import { useEffect, useState } from "react";
import { getUser, hasActionRights, isAccessRoute } from "../../userStore";
import { BtnComponent, formattedDatePp, getUserPictureUrl } from "../../utils/common_lib";
import { MessagesList } from "../messages/messages_list";
import { Icon } from "../../utils/icons";
import { MessageForm } from "../messages/message_form";
import { useGetMessagesQuery } from "../../redux/service/messages_service";
import defaultProfileImg from "../../assests/images/default_profile_img.png";

export const PatientDashboard = (props) => {
  const [showMsgForm, setShowMsgForm] = useState(false);
  const [provider, setProvider] = useState(null);
  const [providerImgSrc, setProviderImgSrc] = useState(defaultProfileImg);
  const [msgPermission, setMsgPermission] = useState(false);
  const patient = getUser();
  const {data: msgData, refetch: refetchMessages, isFetching: isFetchingMessages} = useGetMessagesQuery({type: 'message'});
  const defaultMessages = msgData?.meta?.default_messages || [];

  useEffect(() => {
    if (patient) {
      if (patient?.attending_physician) {
        const picUrl = getUserPictureUrl(patient?.attending_physician.user_id, "provider", 100, 100);
        setProvider({ ...patient?.attending_physician, picUrl: picUrl });
        const img = new Image();
        img.onload = () => setProviderImgSrc(picUrl);
        img.onerror = () => setProviderImgSrc(defaultProfileImg);
        img.src = picUrl;
      }
     
      setMsgPermission(hasActionRights('messages','view'));
    }
  }, []);

  const getBtnText = () => {
    let txt, iconType;
    if (showMsgForm) {
      txt = 'Back';
      iconType = 'arrow-left';
    } else {
      txt = 'New Message';
      iconType = 'arrow-right';
    }
    return <>{txt} <Icon type={iconType} color="gray" size="4" /></>
  }

  return (
    <div className="pb-4">
      {/* Header Section */}
      <div className="bg-gray-200 px-4 py-3 border-b border-gray-300">
        {/* Optional header content can go here */}
      </div>

      {/* Main Content - Stacked on mobile, side-by-side on desktop */}
      <div className="flex flex-col lg:flex-row gap-4 p-4">
        {/* Provider Card - Full width on mobile, half on desktop */}
        <div className="w-full lg:w-6/12">
          <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-lg flex flex-col sm:flex-row gap-4">
            <div className="flex-shrink-0 self-center">
              <img
                src={providerImgSrc}
                alt={provider?.full_name || "Provider"}
                className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gray-100 border border-gray-200 object-cover"
              />
            </div>
            <div className="flex-grow">
              <h2 className="text-xl font-semibold text-gray-800 border-b pb-2 mb-2">
                {provider?.full_name || "Your Provider"}
              </h2>
              {provider?.specialty && (
                <p className="text-sm text-gray-600 capitalize mb-2">
                  {provider.specialty}
                </p>
              )}
              {provider?.practice_address && (
                <p className="text-sm text-gray-600">
                  {provider.practice_address}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Messages Section - Only shown if user has permission */}
        {msgPermission == 1 && (
          <div className="w-full lg:w-6/12">
            <div className="border border-gray-200 rounded-lg shadow-lg overflow-hidden">
              <div className="bg-blue-600 text-white p-3 flex flex-col sm:flex-row justify-between items-center gap-2 ">
                <h3 className="text-lg font-medium">
                  Connect with Careteam
                </h3>
                {hasActionRights('messages', 'add') == 1 && (
                  <BtnComponent
                    btnType="default"
                    onClick={() => setShowMsgForm(!showMsgForm)}
                    text={getBtnText()}
                    className="whitespace-nowrap"
                  />
                )}
              </div>
              <div className="p-4 h-[calc(100vh-270px)] overflow-y-auto bg-gray-50">
                {showMsgForm ? (
                  <MessageForm afterSubmit={() => setShowMsgForm(false)} defaultMessages={defaultMessages} />
                ) : (
                  <MessagesList msgData={msgData} refetchMessages={refetchMessages} isFetchingMessages={isFetchingMessages} />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};